import { twMerge } from "tailwind-merge";
import SquareButton from "./shared/SquareButton";

import PopupTopBar from "@/assets/img/layout/pop-up-top-bar.svg?react";
import IconClose from "@/assets/img/symbolic/close.svg?react";
import { DialogButton } from "./shared/DialogButton";
import { motion } from "framer-motion";

export default function ConfirmationPopUp ({
    className,
    children,
    onClose,
    showCancelButton,
    confirmText,
    onConfirm,
    title,
}: {
    className?: string;
    children?: React.ReactNode;
    onClose: () => void;
    showCancelButton?: boolean;
    confirmText?: string;
    onConfirm: () => void;
    title: string;
})
{
    return (
        <motion.div
            className={Wind.style({
                position: "fixed",
                backgroundColor: "bg-black/50",
                inset: "inset-0",
                display: "flex",
                alignItems: "items-center",
                justifyContent: "justify-center",
                backdropBlur: "backdrop-blur-sm",
                zIndex: "z-[500]"
            }).class}
            onClick={(e) =>
            {
                if (e.target === e.currentTarget)
                {
                    onClose();
                }
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
        >
            <motion.div
                className={twMerge(Wind.style({
                    width: "w-full",
                    marginX: "mx-4"
                }).class, className)}
                initial={{ scale: 0.9, opacity: 0, y: 20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.9, opacity: 0, y: 20 }}
                transition={{ duration: 0.2 }}
            >
                <div
                    className={Wind.style({
                        position: "relative"
                    }).class}
                >
                    <PopupTopBar />
                    <h1
                        className={Wind.style({
                            position: "absolute",
                            top: "top-0",
                            left: "left-0",
                            transformTranslateX: "translate-x-4",
                            height: "h-full",
                            display: "flex",
                            alignItems: "items-center",
                            color: "text-white",
                            fontFamily: "font-default",
                            fontWeight: "font-bold",
                            fontSize: "text-xl",
                            lineHeight: "leading-8",
                            whitespace: "whitespace-nowrap"
                        }).class}
                    >
                        {title}
                    </h1>
                    <SquareButton
                        backgroundColor="#ED254E"
                        className={Wind.style({
                            position: "absolute",
                            top: "-top-2",
                            right: "right-2"
                        }).class + " cancelButton"}
                        onClick={(e) =>
                        {
                            e.stopPropagation();
                            onClose();
                        }}
                    >
                        <IconClose
                            className={Wind.style({
                                color: "text-white",
                                width: "w-6",
                                height: "h-6"
                            }).class}
                        />
                    </SquareButton>
                </div>
                <div
                    className={Wind.style({
                        backgroundColor: "bg-[#C2EABD]",
                        color: "text-dark-blue",
                        textAlign: "text-left",
                        padding: "p-4",
                        fontSize: "text-base",
                        fontWeight: "font-normal",
                        lineHeight: "leading-6",
                        position: "relative",
                        zIndex: "z-[1]",
                        maxHeight: "max-h-[60vh]",
                        overflowY: "overflow-y-auto"
                    }).class}
                    style={{
                        "letterSpacing": "-0.408px",
                    }}
                >
                    {children}
                </div>
                <div
                    className={Wind.style({
                        position: "relative",
                        backgroundColor: "bg-[#C2EABD]",
                        paddingBottom: "pb-2"
                    }).class}
                >
                    <div
                        className={Wind.style({
                            display: "flex",
                            justifyContent: "justify-around",
                            gap: "gap-2",
                            paddingX: "px-2"
                        }).class}
                    >
                        {showCancelButton && (
                            <DialogButton
                                color={"dull-green"}
                                text={"Cancel"}
                                onClick={onClose}
                                className={Wind.style({
                                    flexGrow: "grow"
                                }).class + " cancelButton"}
                            />
                        )}
                        <DialogButton
                            color={"sharp-red"}
                            text={confirmText ?? "Confirm"}
                            onClick={onConfirm}
                            className={Wind.style({
                                flexGrow: "grow"
                            }).class}
                        />
                    </div>
                </div>
            </motion.div>
        </motion.div>
    );
}
